import { FC } from 'react';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { HelperBeeButton } from './HelperBeeButton';

export const HelperBeeCard: FC = () => {
    return (
        <Card padded>
            <div style={{marginBottom: 12}}>
                <Text><b>Innerhive’s BeeLine</b></Text>
            </div>

            <p>
                <Text type="detail">Looking for caregiving solutions or resources? Bea, your AI-powered caregiving consultant, is always here to help with guidance and support.</Text>
            </p>

            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center', display: 'flex', justifyContent: 'center'}}>
                <HelperBeeButton coloredBorder trackingFrom="Caregiver Tools" />
            </div>
        </Card>
    );
};
